
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Layout, Menu, Space, PageHeader, Carousel  } from '@arco-design/web-react';

export default class ARTICLE extends Component{
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  componentDidMount(){
  }
  getBody(){
    return (
      <Space>
        {this.getBannerLink()}
      </Space>
    )
  }
  render() {
    return (<div></div>)
  }
}

